import { getToken } from "../utils/auth";
import { API_BASE_URL } from './URL_Header';

export const fetchAllReturns = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Returns/GetAllReturns`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchAllReturns failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to fetch returns");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const createReturn = async (returnData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/Returns/AddReturn`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify(returnData),
    });
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`createReturn failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to create return");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const deleteReturn = async (id) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Returns/DeleteReturn/${id}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`deleteReturn failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to delete return");
    }
    return response.status === 204 ? {} : await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

// Moved here as requested
export const checkReturnMatch = async (type, driveLink) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Returns/CheckMatch?type=${encodeURIComponent(type)}&driveLink=${encodeURIComponent(driveLink)}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`checkReturnMatch failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to check return match");
    }
    return await response.json(); // Array of { returnId, orderRef, item }
  } catch (err) {
    throw new Error(err.message);
  }
};